import { attrValueToPixels, getBooleanAttribute, getIntegerAttribute, NectaryElement, updateAttribute, updateBooleanAttribute } from '../utils';
const iconStylesHtml = '<style>:host{display:inline-block;vertical-align:middle}svg{display:block;pointer-events:none;fill:var(--sinch-sys-color-text-default);height:var(--sinch-global-size-icon,48px)}.accent{fill:var(--sinch-sys-color-primary-default)}:host([inverted]:not([inverted=false])) svg{fill:var(--sinch-sys-color-text-inverted)}:host([inverted]:not([inverted=false])) .accent{fill:var(--sinch-sys-color-cta-default)}</style>';
const DEFAULT_SIZE = 48;
const MIN_SIZE = 4;
const MAX_SIZE = 256;
export const createIconClass = templateHTML => {
  const template = document.createElement('template');
  template.innerHTML = iconStylesHtml + templateHTML;
  return class extends NectaryElement {
    constructor() {
      super();
      const shadowRoot = this.attachShadow();
      shadowRoot.appendChild(template.content.cloneNode(true));
      this.$svg = shadowRoot.querySelector('svg');
    }
    static get observedAttributes() {
      return ['size'];
    }
    set size(value) {
      updateAttribute(this, 'size', value);
    }
    get size() {
      return getIntegerAttribute(this, 'size', DEFAULT_SIZE);
    }
    set inverted(isInverted) {
      updateBooleanAttribute(this, 'inverted', isInverted);
    }
    get inverted() {
      return getBooleanAttribute(this, 'inverted');
    }
    connectedCallback() {
      updateAttribute(this.$svg, 'preserveAspectRatio', 'xMinYMin meet');
    }
    attributeChangedCallback(name, _, newVal) {
      switch (name) {
        case 'size':
          {
            this.$svg.style.height = attrValueToPixels(newVal, {
              min: MIN_SIZE,
              max: MAX_SIZE
            });
            break;
          }
      }
    }
  };
};